import { api_GET } from './_api';

const fiscalizacaoVeiculo_api = {
    GetPlaca: (placaVeiculo) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoVeiculo/GetPlaca/${placaVeiculo}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default fiscalizacaoVeiculo_api;